module.exports = __webpack_public_path__ + "assets/img/18_1781_big.6f4ddde4.jpg";